/**
 * Emit hosts for the Work-home chrome.
 *
 * They stay app-side because they name a `TrackingEventName` member, which the
 * `@heidi/agents` `/ui` zone refuses: the surface takes this as a port from
 * `src/utils/work-home-ports-wiring.ts`. The payload is the one the banner
 * emitted before the move, byte for byte.
 */
import { track } from '@/lib/analytics/track';
import { TrackingEventName } from '@/models/analytics/eventTypes';
import { ScreenName } from '@heidi/runtime/analytics-vocabulary';

/** The "Set your default page" banner was shown. */
export const trackDefaultLandingPageBannerViewed = (): void => {
  track({
    event_name: TrackingEventName.ScreenViewed,
    props: { screen_name: ScreenName.DefaultLandingPageBanner },
    options: { amplitude: false },
  });
};
